import StartEventHook from './StartEventHook'
import { loadVast } from '../utils'
import Logger from '../Log'
import FillManager from '../FillManager'
import VastFillMethod from '../fillers/VastFillMethod'

const Log = Logger.for('VastHook')

export default class VastStartHook extends StartEventHook {
  constructor () {
    super('VastHook')
  }

  async run (remoteConfig) {
    const bidderList = remoteConfig.bidders()
    const tags = bidderList.filter(b => (b.bidder === 'VAST' || b.bidder === 'IMA'))

    if (!tags || tags.length === 0) return

    const promises = []
    for (const bidder of tags) {
      Log.warn('Checking vast/ima bidder')

      bidderList.splice(bidderList.indexOf(bidder), 1)

      if (!bidder.params.url || !bidder.params.bidder) {
        Log.warn('VAST/IMA tag entry for ' + bidder.params.bidder + ' missing url or partner')
        continue
      }

      const p = loadVast(bidder.params.tag).then(tag => {
        if (!tag) {
          Log.warn('VAST from ' + bidder.params.bidder + ' returned empty tag, skipping')
          Log.debug(tag)
          return
        }

        Log.debug('Got non-empty VAST from ' + bidder.params.bidder + ', registering fill method')

        FillManager.register(new VastFillMethod({
          bidder: bidder.params.bidder,
          params: {
            vast: tag,
            type: bidder.bidder.toLowerCase(),
            ecpm: bidder.params.ecpm
          }
        }))
      })

      promises.push(p)
    }

    await Promise.all(promises).then(() => {
      Log.debug('Pre-processed all vast/ima tags')
    })
  }
}
